import { useShipperCargoDetailPageProps } from "./fetch";
import { ShipperCargoDetailPageUi } from "./ui";

type RouteParams = { cargoIdStr: string };
export const ShipperCargoDetailPage = (params: RouteParams) => {
  const props = useShipperCargoDetailPageProps(params.cargoIdStr);
  return <ShipperCargoDetailPageUi {...props} />;
};
